
import { Component, Inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonModule  } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { Assistance } from '../../../interfaces/assistance';
import { WhitespaceValidator } from '../../../validators/text.validator';
import { MatSelectModule } from '@angular/material/select';



@Component({
  selector: 'assistance-modal',
  imports: [FormsModule, MatInputModule, MatFormFieldModule, MatButtonModule, MatDialogModule, TranslateModule, WhitespaceValidator, MatSelectModule, MatIconModule],
  templateUrl: './assistance-modal.component.html',
  styleUrls: ['./assistance-modal.component.scss']
})

export class AssistanceModalComponent {

  assistance: Assistance = {
    name: '',
    comments: '',
    priority: 0
  };

  assistancePriorityEnum: { [key: string]: number } = {};

  constructor(public dialogRef: MatDialogRef<AssistanceModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.assistancePriorityEnum = data.assistancePriorityEnum;
    this.assistance.priority = this.assistancePriorityEnum['Medium'];
  }

  onSubmit(form: NgForm, sendMail: boolean) {
    console.log("submit", form.valid);
    if (form.valid) this.dialogRef.close({ assistance: this.assistance, sendMail: sendMail });
  }

  objectKeys(obj: { [key: string]: any }): string[] {
    return Object.keys(obj);
  }

}
